import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import './navigationPulpit.css';

const NavigationPulpit = (props) => {
    let [steps, setSteps] = useState({
        one: false,
        two: false,
        three: false,
    });
    let choose1 = 0;

    const [stepIndex, setStepIndex] = useState(props.choosen);

    return (
        <>
            <div className="stepsNavigationPulpit">
                {props.stepsList.map((step, index) => {
                    return (
                        <div key={index}
                            onClick={() => {
                                props.onChoosenChange(index);
                                setStepIndex(index);
                            }}
                            className={
                                stepIndex == index
                                    ? 'stepsNavigationPulpit_boxItem choosenItemPulpit'
                                    : 'stepsNavigationPulpit_boxItem'
                            }
                        >
                            <p>{step}</p>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default NavigationPulpit;
